module.exports = __webpack_public_path__ + "img/invoice_logo.f4ae4e58.png";